export function getFormValues(formEl) {    
    if (!formEl) {
        console.error('Form not passed');
        return {};
    }
    
    const values = {};
    const counters = {}; // Track occurrences of each field name
    
    const internalInputs = Array.from(formEl.querySelectorAll('input, select, textarea'));

    // Select all elements outside the form with a matching form attribute
    const externalInputs = Array.from(document.querySelectorAll(
        `input[form="${formEl.id}"], select[form="${formEl.id}"], textarea[form="${formEl.id}"]`
    ));

    // Merge the internal and extern input arrays into one
    const inputs = [...internalInputs, ...externalInputs];

    inputs.forEach(input => {
        const { value, name: key, type } = input;

        // TODO: Create data attributes for "ignore-retrieval" or "ignore-validation" instead of "is-js-template"
        // would be better name and cover "data-is-js-template" use case, as well as "atb-dropdown-search" 
        // TODO: Add that attribute to the search input
        if (input.id.includes('type-1') ||
            input.hasAttribute('data-is-js-template') || 
            input.classList.contains('atb-dropdown-search') ||
            input.classList.contains('iti__search-input'))
            return;

        const val = getInputValue(input, value);

        // 🧠 handle multiple inputs with the same name 
        // track how many times each name appears by using a counters object 
        counters[key] = (counters[key] || 0) + 1;
        const index   = counters[key] - 1;
        const isFirst = index === 0;

        if (isFirst) {
            values[key] = val;
        } else {
            if (index === 1 && values[key] !== undefined) {
                values[`${key}[0]`] = values[key];
                delete values[key];
            }
            values[`${key}[${index}]`] = val;
        }
    });

    return values;
}


/**
 * Format phone number using intl-tel-input library if available
 * @param {HTMLInputElement} input - The phone input element
 * @returns {string} Formatted phone number or raw value
 */
function formatPhoneNumber(input) {
    // If intl-tel-input is initialized, use E.164 format
    if (input._iti && input._iti.isValidNumber()) {
        return input._tti.getNumber(); // clean, server-ready
    }
    return input.value; // fallback
}

/**
 * Get the value from an input element, handling special input types
 * @param {HTMLInputElement} input - The input element
 * @param {string} value - The raw value from the input
 * @returns {string|number} The processed value
 */
function getInputValue(input, value) {
    const { type } = input;

    // Handle checkboxes
    if (type === "checkbox") {
        return input.checked ? 1 : 0;
    }

    // Handle dropdown inputs with data-selected-id attribute
    if (input.hasAttribute('data-selected-id')) {
        return input.dataset.selectedId || "";
    }

    // Handle phone numbers
    if (type === "tel") {
        return formatPhoneNumber(input);
    }

    return value;
}